import React from 'react';
import { AlertCircle, RefreshCw, X } from 'lucide-react';
import { getUserFriendlyError } from '../utils/errorHelper';

interface ErrorDisplayProps {
  error: any;
  context: { action: string; item?: string };
  onRetry?: () => void;
  onDismiss?: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  context,
  onRetry,
  onDismiss,
}) => {
  const errorMessage = getUserFriendlyError(error);

  // Extract solution from error message if it contains actionable advice
  const getSolution = (message: string): string => {
    if (message.includes('internetkapcsolat')) {
      return 'Ellenőrizd az internetkapcsolatot és próbáld újra. Ha a probléma továbbra is fennáll, várj egy pillanatot és próbáld újra.';
    }
    if (message.includes('jogosultság')) {
      return 'Kérlek jelentkezz be újra vagy lépj kapcsolatba az adminisztrátorral.';
    }
    if (message.includes('már létezik')) {
      return 'Használj másik azonosítót vagy szerkeszd a meglévő elemet a Dashboard-on.';
    }
    if (message.includes('nem található')) {
      return 'Lehet, hogy az elem törölve lett vagy nem létezik. Frissítsd az oldalt vagy ellenőrizd a keresést.';
    }
    return 'Kérlek próbáld újra. Ha a probléma továbbra is fennáll, jelezd a támogatásnak.';
  };

  const solution = getSolution(errorMessage);

  return (
    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <AlertCircle className="text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" size={20} />
        <div className="flex-1 min-w-0">
          <h4 className="font-bold text-red-800 dark:text-red-200 mb-1">Hiba: {context.action}</h4>
          <p className="text-sm text-red-700 dark:text-red-300 mb-2">{errorMessage}</p>
          <p className="text-xs text-red-600 dark:text-red-400 mb-3 italic">{solution}</p>
          <div className="flex gap-2">
            {onRetry && (
              <button
                onClick={onRetry}
                className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg flex items-center gap-1 transition"
              >
                <RefreshCw size={14} />
                Újrapróbálás
              </button>
            )}
            {onDismiss && (
              <button
                onClick={onDismiss}
                className="px-3 py-1.5 text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/30 text-sm rounded-lg transition"
              >
                Bezárás
              </button>
            )}
          </div>
        </div>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="text-red-400 hover:text-red-600 dark:hover:text-red-300 flex-shrink-0 transition"
            aria-label="Bezárás"
          >
            <X size={18} />
          </button>
        )}
      </div>
    </div>
  );
};
